/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {EnvironmentalBenefitValueEditor} from "./EnvironmentalBenefitValueEditor";

export function ProgramEnvironmentalBenefitsTargetValueEditor(props) {
	const {Data = {}} = props;
	const {environmentalBenefitId} = Data;
	return <EnvironmentalBenefitValueEditor
		environmentalBenefitId={environmentalBenefitId}
		{...props}
	/>;
}